import { render, staticRenderFns } from "./TaxInput.ui.vue?vue&type=template&id=5145279d&scoped=true"
import script from "./TaxInput.ui.vue?vue&type=script&lang=js"
export * from "./TaxInput.ui.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145279d",
  null
  
)

export default component.exports